import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function ArticleSection() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block border border-accent-300 text-accent-700 text-xs font-medium px-4 py-1 rounded-full mb-4">
            Blog &amp; Guias
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-tight max-w-2xl mx-auto">
            Conteúdo exclusivo<br />sobre CSSBuy
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            Artigos detalhados para ajudar nas suas compras com o CSSBuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
          {allArticles.map((artigo) => (
            <Link
              key={artigo.slug}
              to={`/artigo/${artigo.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden hover:bg-accent-50 transition-colors duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={artigo.image}
                  alt={artigo.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-1">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 group-hover:bg-accent-200 transition-colors mb-4">
                  <i className={`${artigo.icon} text-lg text-accent-600`}></i>
                </div>
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-accent-700 transition-colors leading-snug">
                  {artigo.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed flex-1 line-clamp-3">
                  {artigo.metaDescription}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-xs font-semibold text-accent-600 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                  Ler artigo
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-[11px]"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}